export default "__VITE_ASSET__yySOUWKJ__"